import { ActionOverRecordTypes, FieldBuilder, FieldDefinition, IActionsSchema, LocationTypes, MENU_CATEGORY_KEY, MENU_NAME_SUFFIX, MENU_SUBCATEGORY_KEY, MenuCategories, MenuSubcategories, PERIOD_TYPE_NAME_PLANNED_PLANNING_SEASON, triggerAction, ZendraLocalizationServices } from '@zendra/shared';
import { LocationService, PeriodService, VendorService } from 'cbd-proxies';

FieldBuilder.setNamespace('Operational');

export const TILLAGEPLAN_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('weekNumber', 'Entity.TillagePlan.WeekNumber')
    .required()
    .build(),
  FieldBuilder
    .number('year', 'Entity.TillagePlan.Year')
    .required()
    .build(),
  FieldBuilder
    .number('tillageProgressArea', 'Entity.TillagePlan.TillageProgressArea')
    .required()
    .decimal()
    .build(),
  FieldBuilder
    .number('tillageProgressPercentage', 'Entity.TillagePlan.TillageProgressPercentage')
    .hideInChildForms()
    .decimal()
    .build(),
  FieldBuilder.foreignKey(
    'periodId',
    'Entity.TillagePlan.Period',
    PeriodService
  )
    .required()
    .queryFilter({ periodTypeName: PERIOD_TYPE_NAME_PLANNED_PLANNING_SEASON })
    .display('name')
    .displayFromNested('periodName')
    .sortBy('periodName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'propertyLocationId',
    'Entity.Property',
    LocationService
  )
    .required()
    .queryFilter({ locationTypeEntityName: LocationTypes.Property })
    .display('name')
    .displayFromNested('propertyLocationName')
    .sortBy('propertyLocationName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'vendorId',
    'Entity.Vendor',
    VendorService
  )
    .required()
    .display('fantasyName')
    .displayFromNested('vendorFantasyName')
    .sortBy('vendorFantasyName')
    .keyField('id')
    .build(),
];

const namespace = ZendraLocalizationServices.Operational;

export const TILLAGEPLAN_ACTION_IDS = {
  calculatePercentageTillage: 0,
  importExcelModal: 1,
  downloadExcelTemplateTrigger: 2,
};

export const TILLAGEPLAN_ACTIONS_CONFIG: IActionsSchema = {
  overTable: [
    triggerAction(
      TILLAGEPLAN_ACTION_IDS.importExcelModal,
      'Action.Modal.ImportTillagePlan',
      ActionOverRecordTypes.OverTable,
      ZendraLocalizationServices.Operational,
    ),
    triggerAction(
      TILLAGEPLAN_ACTION_IDS.downloadExcelTemplateTrigger,
      'Actions:ExcelTemplateDownload',
      ActionOverRecordTypes.OverTable,
      ZendraLocalizationServices.LanguageService,
    ),
  ],
  multipleRecord: [
    triggerAction(
      TILLAGEPLAN_ACTION_IDS.calculatePercentageTillage,
      'Action.Trigger.CalculatePercentageTillage',
      ActionOverRecordTypes.MultipleRecord,
      namespace,
    ),
  ],
};

export const TILLAGEPLAN_CONFIG = {
  entityName: 'TillagePlan',
  localizationKey: 'Operational::Entity.TillagePlan',
  fields: TILLAGEPLAN_FIELDS,
  permission: 'PlanningOperation.TillagePlans',
  actions: TILLAGEPLAN_ACTIONS_CONFIG,
  actionIds: TILLAGEPLAN_ACTION_IDS,
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.PlanningOperational + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Tillage + MENU_NAME_SUFFIX,
};
